import React from 'react';
import { Modal } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import Button from '../../../../Components/Button';
import Group from '../../../../Components/FormsElements/Group';
import Input from '../../../../Components/FormsElements/Input';
import TextArea from '../../../../Components/FormsElements/textArea';
import { Label } from '../../../../Components/FormsElements/utils';
import EditProfileGemsBox from '../../../../Components/GEMSComponent/EditProfileGemsBox';
import styles from './styles.module.scss';
const EditProfileModal = (props) => {
    const userData = props?.userData;
    const hiddenProfileModal = React.useRef(null);
    const handleClickEditModal = (event) => {
        hiddenProfileModal.current.click();
    };
    const handleChangeModal = (event) => {
        if (event.target.files && event.target.files[0]) {
            props?.editProfileFormikModal?.setValues((v) => {
                return {
                    ...v,
                    profile_photo: URL.createObjectURL(event.target.files[0]),
                    profile_file_data: event.target.files[0],
                };
            });
            props?.setProfilePhoto(event.target.files[0]);
        }
    };
    return (
        <>
            <Modal
                show={props.show}
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header
                    closeButton
                    className={`${styles.nomodalborder}`}
                ></Modal.Header>
                <Modal.Body>
                    <div className={`${styles.edit_box}`}>
                        <div className={`${styles.editgemspacing}`}>
                            <EditProfileGemsBox />
                        </div>
                        <div className={`${styles.edit_details_separates}`}>
                            <div className={`${styles.img_separates}`}>
                                <div className={`${styles.img_section}`}>
                                    {userData?.is_verified === 1 ? (
                                        <span
                                            className={`${styles.author__avatar__verified}`}
                                        >
                                            <svg
                                                width="28"
                                                height="28"
                                                viewBox="0 0 20 21"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M12.5827 1.58755C12.2463 1.24322 11.8444 0.969621 11.4007 0.782824C10.957 0.596027 10.4804 0.499802 9.99899 0.499802C9.51757 0.499802 9.04101 0.596027 8.5973 0.782824C8.1536 0.969621 7.75171 1.24322 7.41524 1.58755L6.63774 2.38505L5.52524 2.3713C5.04368 2.3656 4.56584 2.45624 4.11982 2.63791C3.6738 2.81957 3.26861 3.08858 2.92807 3.42912C2.58753 3.76966 2.31852 4.17485 2.13685 4.62087C1.95519 5.06689 1.86454 5.54473 1.87024 6.0263L1.88274 7.1388L1.08774 7.9163C0.74342 8.25276 0.46982 8.65465 0.283023 9.09836C0.0962258 9.54206 0 10.0186 0 10.5C0 10.9815 0.0962258 11.458 0.283023 11.9017C0.46982 12.3454 0.74342 12.7473 1.08774 13.0838L1.88399 13.8613L1.87024 14.9738C1.86454 15.4554 1.95519 15.9332 2.13685 16.3792C2.31852 16.8252 2.58753 17.2304 2.92807 17.571C3.26861 17.9115 3.6738 18.1805 4.11982 18.3622C4.56584 18.5438 5.04368 18.6345 5.52524 18.6288L6.63774 18.6163L7.41524 19.4113C7.75171 19.7556 8.1536 20.0292 8.5973 20.216C9.04101 20.4028 9.51757 20.499 9.99899 20.499C10.4804 20.499 10.957 20.4028 11.4007 20.216C11.8444 20.0292 12.2463 19.7556 12.5827 19.4113L13.3602 18.615L14.4727 18.6288C14.9543 18.6345 15.4321 18.5438 15.8782 18.3622C16.3242 18.1805 16.7294 17.9115 17.0699 17.571C17.4105 17.2304 17.6795 16.8252 17.8611 16.3792C18.0428 15.9332 18.1334 15.4554 18.1277 14.9738L18.1152 13.8613L18.9102 13.0838C19.2546 12.7473 19.5282 12.3454 19.715 11.9017C19.9018 11.458 19.998 10.9815 19.998 10.5C19.998 10.0186 19.9018 9.54206 19.715 9.09836C19.5282 8.65465 19.2546 8.25276 18.9102 7.9163L18.114 7.1388L18.1277 6.0263C18.1334 5.54473 18.0428 5.06689 17.8611 4.62087C17.6795 4.17485 17.4105 3.76966 17.0699 3.42912C16.7294 3.08858 16.3242 2.81957 15.8782 2.63791C15.4321 2.45624 14.9543 2.3656 14.4727 2.3713L13.3602 2.3838L12.5827 1.5888V1.58755ZM12.9415 9.06755L9.19149 12.8175C9.13344 12.8758 9.06447 12.9219 8.98854 12.9534C8.9126 12.9849 8.8312 13.0012 8.74899 13.0012C8.66678 13.0012 8.58538 12.9849 8.50945 12.9534C8.43352 12.9219 8.36455 12.8758 8.30649 12.8175L6.43149 10.9425C6.37338 10.8844 6.32729 10.8154 6.29584 10.7395C6.26439 10.6636 6.2482 10.5822 6.2482 10.5C6.2482 10.4179 6.26439 10.3365 6.29584 10.2606C6.32729 10.1846 6.37338 10.1157 6.43149 10.0575C6.4896 9.99944 6.55859 9.95334 6.63451 9.92189C6.71044 9.89044 6.79181 9.87426 6.87399 9.87426C6.95617 9.87426 7.03755 9.89044 7.11347 9.92189C7.1894 9.95334 7.25838 9.99944 7.31649 10.0575L8.74899 11.4913L12.0565 8.18255C12.1739 8.06519 12.333 7.99926 12.499 7.99926C12.665 7.99926 12.8241 8.06519 12.9415 8.18255C13.0589 8.2999 13.1248 8.45908 13.1248 8.62505C13.1248 8.79102 13.0589 8.95019 12.9415 9.06755Z"
                                                    fill="#7557BB"
                                                />
                                            </svg>
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                    <img
                                        src={`${
                                            props?.editProfileFormikModal
                                                ?.values?.profile_photo
                                                ? props?.editProfileFormikModal
                                                      ?.values?.profile_photo
                                                : '/assets/img/avatars/user_avatar5.jpg'
                                        }`}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null; // prevents looping
                                            currentTarget.src =
                                                'https://d27qmp29yp5bvv.cloudfront.net/profile/profile-123048264259194837.webp';
                                        }}
                                        alt="Profile Pic"
                                    />
                                    <div className={`${styles.editIcon}`}>
                                        <SVG
                                            src="/assets/vectors/editProfile.svg"
                                            width="18px"
                                            height="18px"
                                            onClick={() => {
                                                handleClickEditModal();
                                            }}
                                        />
                                        <input
                                            // value={filesList}
                                            type="file"
                                            ref={hiddenProfileModal}
                                            style={{ display: 'none' }}
                                            onChange={handleChangeModal}
                                            id={'UpdateProfile'}
                                            accept={'image/*'}
                                            name={'UpdateProfileF'}
                                        />
                                    </div>
                                </div>
                                <p className={`${styles.profile_heading}`}>
                                    Set Your Profile Photo
                                </p>
                                <p
                                    className={`${styles.profile_heading} text-danger pl-1`}
                                >
                                    {
                                        props?.editProfileFormikModal?.errors
                                            .profile_photo
                                    }
                                </p>
                            </div>

                            <div className={`${styles.edit_form_separates}`}>
                                <div className={`${styles.input_form1}`}>
                                    <Group
                                        className={`${styles.input_sections}`}
                                    >
                                        <Label
                                            className={`label`}
                                            title={`Name`}
                                        />
                                        <Input
                                            label={'Name'}
                                            type={'text'}
                                            value={
                                                props?.editProfileFormikModal
                                                    ?.values.name
                                            }
                                            id="name"
                                            placeHolder={`Full Name`}
                                            onChange={(e) => {
                                                props?.editProfileFormikModal?.setValues(
                                                    (v) => {
                                                        return {
                                                            ...v,
                                                            name: e.target
                                                                .value,
                                                        };
                                                    }
                                                );
                                            }}
                                            onBlur={
                                                props?.editProfileFormikModal
                                                    ?.handleBlur
                                            }
                                            touched={
                                                props?.editProfileFormikModal
                                                    ?.touched.name
                                            }
                                            error={
                                                props?.editProfileFormikModal
                                                    ?.errors.name
                                            }
                                        />
                                    </Group>

                                    <Group
                                        className={`${styles.input_sections}`}
                                    >
                                        <div
                                            className={`${styles.lable_separates}`}
                                        >
                                            <Label
                                                className={`${styles.lables} label`}
                                                title={`Social Media link`}
                                            />
                                            <span
                                                className={`${styles.secondary_lable}`}
                                            >
                                                *Any One
                                            </span>
                                        </div>
                                        <div
                                            className={`${styles.social_separates}`}
                                        >
                                            <div
                                                className={`${styles.fb_icons} ${
                                                    props
                                                        ?.editProfileFormikModal
                                                        ?.values.social_icon ===
                                                    1
                                                        ? styles.fb_active
                                                        : ''
                                                } `}
                                            >
                                                <SVG
                                                    src="/assets/vectors/facebook_logo.svg"
                                                    width="24px"
                                                    height="24px"
                                                    onClick={() =>
                                                        props?.editProfileFormikModal?.setValues(
                                                            (v) => {
                                                                return {
                                                                    ...v,
                                                                    social_icon: 1,
                                                                    social_url:
                                                                        props
                                                                            ?.editProfileFormikModal
                                                                            ?.values
                                                                            ?.facebook_url,
                                                                };
                                                            }
                                                        )
                                                    }
                                                />
                                            </div>

                                            <div
                                                className={`${styles.twitter_icons} ${
                                                    props
                                                        ?.editProfileFormikModal
                                                        ?.values.social_icon ===
                                                    2
                                                        ? styles.twitter_active
                                                        : ''
                                                }`}
                                            >
                                                <SVG
                                                    src="/assets/vectors/twitter_logo.svg"
                                                    width="24px"
                                                    height="24px"
                                                    onClick={() =>
                                                        props?.editProfileFormikModal?.setValues(
                                                            (v) => {
                                                                return {
                                                                    ...v,
                                                                    social_icon: 2,
                                                                    social_url:
                                                                        props
                                                                            ?.editProfileFormikModal
                                                                            ?.values
                                                                            ?.twitter_url,
                                                                };
                                                            }
                                                        )
                                                    }
                                                />
                                            </div>

                                            <div
                                                className={`${styles.telegram_icons} ${
                                                    props
                                                        ?.editProfileFormikModal
                                                        ?.values.social_icon ===
                                                    3
                                                        ? styles.telegram_active
                                                        : ''
                                                } `}
                                            >
                                                <SVG
                                                    src="/assets/vectors/telegram_logo.svg"
                                                    width="24px"
                                                    height="24px"
                                                    onClick={() =>
                                                        props?.editProfileFormikModal?.setValues(
                                                            (v) => {
                                                                return {
                                                                    ...v,
                                                                    social_icon: 3,
                                                                    social_url:
                                                                        props
                                                                            ?.editProfileFormikModal
                                                                            ?.values
                                                                            ?.instagram_url,
                                                                };
                                                            }
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <Input
                                            label={'Socail Media URL'}
                                            type={'text'}
                                            placeHolder={` ${
                                                props?.editProfileFormikModal
                                                    ?.values.social_icon === 1
                                                    ? 'Facebook Social Media link'
                                                    : props
                                                            ?.editProfileFormikModal
                                                            ?.values
                                                            .social_icon === 2
                                                      ? 'Twitter Social Media link'
                                                      : props
                                                              ?.editProfileFormikModal
                                                              ?.values
                                                              .social_icon === 3
                                                        ? 'Telegram Social Media link'
                                                        : 'Social Media Link'
                                            }
                        `}
                                            value={
                                                props?.editProfileFormikModal
                                                    ?.values.social_url
                                            }
                                            onChange={(e) => {
                                                props?.editProfileFormikModal?.setValues(
                                                    (v) => {
                                                        return {
                                                            ...v,
                                                            social_url:
                                                                e.target.value,
                                                        };
                                                    }
                                                );
                                            }}
                                            id="social_url"
                                            onBlur={
                                                props?.editProfileFormikModal
                                                    ?.handleBlur
                                            }
                                            touched={
                                                props?.editProfileFormikModal
                                                    ?.touched.social_url
                                            }
                                            error={
                                                props?.editProfileFormikModal
                                                    ?.errors.social_url
                                            }
                                            disable={
                                                props?.editProfileFormikModal
                                                    ?.values.social_icon &&
                                                props?.editProfileFormikModal
                                                    ?.values.social_icon !== ''
                                                    ? false
                                                    : true
                                            }
                                        />
                                    </Group>
                                    <Group
                                        className={`${styles.input_sections}`}
                                    >
                                        <Label
                                            className={`label`}
                                            title={`Website URL`}
                                        />
                                        <Input
                                            label={'Website URL'}
                                            type={'text'}
                                            placeHolder={`Enter Website Url`}
                                            value={
                                                props?.editProfileFormikModal
                                                    ?.values.website_url
                                            }
                                            onChange={(e) => {
                                                props?.editProfileFormikModal?.setValues(
                                                    (v) => {
                                                        return {
                                                            ...v,
                                                            website_url:
                                                                e.target.value,
                                                        };
                                                    }
                                                );
                                            }}
                                            id="website_url"
                                            onBlur={
                                                props?.editProfileFormikModal
                                                    ?.handleBlur
                                            }
                                            touched={
                                                props?.editProfileFormikModal
                                                    ?.touched.website_url
                                            }
                                            error={
                                                props?.editProfileFormikModal
                                                    ?.errors.website_url
                                            }
                                        />
                                    </Group>
                                </div>

                                <div className={`${styles.input_form2}`}>
                                    <Group
                                        className={`${styles.input_sections}`}
                                    >
                                        <Label
                                            className={`label`}
                                            title={`Bio`}
                                            // LabelinfoTextComponent={`(Optional)`}
                                        />
                                        <TextArea
                                            rows="8"
                                            label={`Bio`}
                                            seconLabel={`Optional`}
                                            value={
                                                props?.editProfileFormikModal
                                                    ?.values.bio
                                            }
                                            onChange={(e) => {
                                                props?.editProfileFormikModal?.setValues(
                                                    (v) => {
                                                        return {
                                                            ...v,
                                                            bio: e.target.value,
                                                        };
                                                    }
                                                );
                                            }}
                                            id="bio"
                                            onBlur={
                                                props?.editProfileFormikModal
                                                    ?.handleBlur
                                            }
                                            touched={
                                                props?.editProfileFormikModal
                                                    ?.touched.bio
                                            }
                                            error={
                                                props?.editProfileFormikModal
                                                    ?.errors.bio
                                            }
                                            placeHolder={`Eg: Savage Dogs is the art of Martin Bekerman, a creative from Buenos Aires, based in California.`}
                                        />
                                    </Group>
                                    <Group className={`${styles.input_btns}`}>
                                        <Button
                                            varient={'primary'}
                                            onClick={() =>
                                                props?.editProfileFormikModal.handleSubmit()
                                            }
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            varient={'secondary_outline'}
                                            onClick={props.onHide}
                                            style={{
                                                marginLeft: '20px',
                                            }}
                                        >
                                            Skip For Now
                                        </Button>
                                    </Group>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className={`${styles.nomodalborder}`}>
                    &nbsp;
                    {/* <Button onClick={props.onHide}>Close</Button> */}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditProfileModal;
